import uuidV4 from 'lib/string/uuidV4Utils'
import { CHECKOUT_ITEM_TYPE_GIFT_CARD } from 'constants/checkout'
import config from 'constants/config'

export function generateGiftCardItem(amount: number): App.Checkout.GiftCardItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_GIFT_CARD,
    amount,
    deliveryMethod: 'email',
    content: {},
  }
}

export function generateExperienceGiftCardItem(
  experience: App.ExperienceOffer,
  amount: number,
  ticketCounts: Array<{ ticket: App.ExperienceItemTicket, count: number }>,
): App.Checkout.GiftCardItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_GIFT_CARD,
    amount,
    deliveryMethod: 'email',
    content: {},
    product: {
      image: experience.images[0],
      items: ticketCounts.map((ticketItem) => `${ticketItem.ticket.name}${ticketItem.count > 1 ? ` x ${ticketItem.count}` : ''}`),
      name: experience.name,
      type: 'experience',
      location: experience.location.name,
      url: `${config.SCHEME}://${config.CUSTOMER_PORTAL_HOST}/experience/${experience.slug}/${experience.id}`,
    },
  }
}
